import React from 'react'
import StudentHeader from '../common/StudentHeader';

const StudentDashboard = () => {
  return (
    <>
    <StudentHeader />
    <div>Welcome Student Dashboard</div>
    </>
  )
}

export default StudentDashboard;